import { render, staticRenderFns } from "./CourseBuilderDocumentForm.vue?vue&type=template&id=27b1a27f&scoped=true&"
import script from "./CourseBuilderDocumentForm.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderDocumentForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseBuilderDocumentForm.vue?vue&type=style&index=0&id=27b1a27f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b1a27f",
  null
  
)

export default component.exports